import { render, staticRenderFns } from "./hire.vue?vue&type=template&id=586e6972&scoped=true"
import script from "./hire.vue?vue&type=script&lang=js"
export * from "./hire.vue?vue&type=script&lang=js"
import style0 from "./hire.vue?vue&type=style&index=0&id=586e6972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586e6972",
  null
  
)

export default component.exports